import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-16 md:px-8 md:py-24" data-id="element-293" data-mp="3fz5nrwzgtig9">
      <div className="mx-auto max-w-5xl" data-id="element-294" data-mp="3fxb3mkw0pud8">
        <h2 className="text-center font-serif text-[1.85rem] font-extrabold leading-tight text-navy-900 sm:text-4xl md:text-5xl" data-id="element-295" data-mp="3azjc3rzaca9k">
          What dentists are saying about the blueprint
        </h2>
        <div className="mt-4 flex items-center justify-center gap-1" aria-label="Rated 5 out of 5" data-id="element-296" data-mp="31zmqjz86zriq">
          {Array.from({
          length: 5
        }).map((_, i) => <StarIcon key={i} className="h-6 w-6 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-297" data-mp="2x2ml9qj62sso" data-mpi={i} />)}
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-298" data-mp="v9yhng2m23cd">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-ivory p-6 ring-1 ring-navy-900/10 sm:p-8" data-id="element-299" data-mp="q9tytje8cwiz">
              <div className="flex gap-1" aria-hidden="true" data-id="element-300" data-mp="h5ooj7qca05u">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold-400 text-gold-400" data-id="element-301" data-mp="m6m73lf9gw7v" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-lg leading-relaxed text-ink" data-id="element-302" data-mp="79v3ezyk0ycg">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-6" data-id="element-303" data-mp="c8y3e5zogedk">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-gold-400" data-id="element-304" data-mp="zwy1xs38d92p" />
                <div data-id="element-305" data-mp="14xdcyd01i4hi">
                  <p className="flex items-center gap-1.5 text-base font-bold text-navy-900" data-id="element-306" data-mp="q7650r7ns3v2">
                    {t.name}
                    <BadgeCheckIcon className="h-5 w-5 text-emerald-600" aria-label="Verified buyer" data-id="element-307" data-mp="v4o5dt7m1arg" />
                  </p>
                  <p className="text-sm text-muted" data-id="element-308" data-mp="1itz99jk9bl9t">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCTA label="Join These Dentists — Get It for $27" data-id="element-309" data-mp="1xiiq6pqkn8fj" />
      </div>
    </section>;
}